import { render, staticRenderFns } from "./integralOrderCreate.vue?vue&type=template&id=37f6a6cf&scoped=true"
import script from "./integralOrderCreate.vue?vue&type=script&lang=js"
export * from "./integralOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./integralOrderCreate.vue?vue&type=style&index=0&id=37f6a6cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6a6cf",
  null
  
)

export default component.exports